<template>
    <div class="d-flex flex-column overflow-hidden position-relative">
        <div class="rounded-corners overflow-hidden position-relative"
             :class="{'alert-danger': file.error, 'alert-info': file.uploading, 'border': !file.isImage, 'mb-2': !file.isImage}"
             :style="{
                width: getWidth + 'px',
                height: getHeight + 'px',
                cursor: 'pointer'
             }">
            <div v-if="!file.uploading && !file.error" class="w-100 h-100">

                <div v-if="file.isImage" class="gallery-image position-absolute w-100 h-100" :style="{
                    'background-image': 'url(' + file.getMediaUrl() + ')' ,
                    'background-size': 'cover',
                }">
                </div>
                <div v-if="!file.isImage"
                     class="d-flex align-items-center justify-content-center flex-column
                     w-100 h-100 text-center position-relative">
                    <div class="h1 text-info"><b-icon icon="file-earmark" size="sm"/></div>
                    <div v-if="updating" class="position-absolute d-flex w-100 h-100 align-items-center justify-content-center bg-secondary">
                        <b-spinner variant="light" />
                    </div>
                </div>

                <div v-if="removing" class="d-flex w-100 h-100 align-items-center justify-content-center">
                    <b-spinner variant="light" />
                </div>
                <div v-if="removable && !updating">
                    <slot name="remove">
                        <button class="gallery-remove-button" @click.prevent.stop="onRemove">
                            <span class="gallery-remove-button-icon">
                                <b-icon icon="trash" v-if="file.serverSide"/>
                                <b-icon icon="x" v-else/>
                            </span>
                        </button>
                    </slot>
                </div>

            </div>

            <div v-else class="w-100 h-100">
                <div class="d-flex align-items-center justify-content-center w-100 h-100 text-center flex-column">
                    <div v-if="!file.error"><b-spinner variant="info" /></div>
                    <div v-else><small class="text-danger">Ошибка при загрузке</small></div>
                    <small style="  overflow-wrap: break-word;
      word-wrap: break-word;
      hyphens: auto;">{{ file.file.name }}</small>
                </div>

                <div v-if="removable && file.error && !file.id">
                    <button class="gallery-remove-button bg-white" @click.prevent.stop="onFailedRemove">
                        <span class="gallery-remove-button-icon">
                            <b-icon icon="x" />
                        </span>
                    </button>
                </div>
            </div>

        </div>
        <div class="d-flex flex-column" :style="{width: getWidth + 'px'}">
            <b-input v-model="file.serverName"
                     v-if="hasFileNameInput && removable && file.id && !file.isImage"
                     @click.stop.prevent
                     @input="onChangeDescription"/>
            <span v-if="hasFileNameInput && !removable && file.id && !file.isImage" >
                {{ file.serverName }}
            </span>
        </div>
    </div>
</template>

<script>
    import httpClient from "../../http";
    import api from "@/api";
    import debounce from "debounce";

    export default {
        name: "GalleryThumbnail",
        props: {
            file: { type: Object, default: () => { return {} }},
            apiUrl: { type: String },
            removable: { type: Boolean, default: true },
            size: { type: Number, default: 200 },
            width: { type: Number, default: 200 },
            height: { type: Number, default: 200 },
            hasFileNameInput: { type: Boolean, default: false },
            deleteOnRemove: { type: Boolean, default: true },
        },
        computed: {
            getApiUrl() {
                if (this.file.serverSide && this.apiUrl && this.file.id) {
                    return this.apiUrl + this.file.id
                }
            },
            getWidth() {
                return this.width > 0 ? this.width : this.size
            }
            ,
            getHeight() {
                return this.height > 0 ? this.height : this.size
            }
        },
        data() {
            return {
                removing: false,
                updating: false
            }
        },
        methods: {
            onRemove() {
                const vm = this;
                const url = this.getApiUrl;
                if (url && vm.deleteOnRemove) {
                    vm.removing = true;
                    httpClient.delete(url)
                        .then(response => {
                            vm.$emit('file-removed', {uuid: this.file.uuid});
                            vm.removing = false;
                        })
                        .catch(reason => {  vm.removing = false; })
                } else {
                    vm.$emit('file-removed', {uuid: this.file.uuid});
                }
            },
            onFailedRemove() {
                this.$emit('failed-file-removed', {uuid: this.file.uuid})
            },
            changeDescription: debounce((vm, item) => {
                if (item) {
                    const url = api.attachments.default.detail(vm.file.id);
                    vm.updating = true
                    httpClient.patch(url, { name: item })
                        .then(() => {
                            vm.$bvToast.toast('Имя документа изменено', {noCloseButton: true, solid: true,  autoHideDelay: 5000, variant: 'success'})
                            // vm.$emit('gallery-item-name-changed');
                        })
                        .finally(() => {
                            vm.updating = false
                        })
                }
            }, 1000),
            onChangeDescription(item) { // TODO debounce
                this.changeDescription(this, item)
            },

        }

    }
</script>

<style scoped lang="scss">
@import 'node_modules/bootstrap/scss/bootstrap.scss';
@import 'node_modules/bootstrap-vue/src/index.scss';
    .rounded-corners {
        border-radius: 8px ;
    }
    .gallery-image {
        overflow-wrap: break-word;
        transition: 0.2s ease transform;
        &:hover {
            transform: scale(1.1);
        }
    }

    .alert-info,.alert-danger {
        & .gallery-remove-button {
            background-color: #FFFFFF;
        }
    }

    .gallery-remove-button {
        background-color: white;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 5px;
        top: 5px;
        border: 0;

        transition: 0.2s;
        &:hover {
            transform: scale(1.1);
        }
    }
    .gallery-remove-button-icon {
        position: absolute;
        right: 5px;
        top: -1px;
        pointer-events: none;
        font-size: 1.6em;
        color: $gray-600;

    }
</style>